import styled from 'styled-components';

import {Button} from '../../styles/components/button.style';
import {padding} from '../../styles/core/padding.style';

export const Title = styled.h3`
  font-size: 2.4rem;
  margin: 0;
`;

export const Paragraph = styled.p`
  font-size: 1.4rem;
  line-height: 2.4rem;
  margin-bottom: ${padding.padding12};
`;

export const Ok = Button.extend`
  float: right;
`;



// WEBPACK FOOTER //
// ./components/DeliveryMinimumModal/DeliveryMinimumModal.style.js